var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlighter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_14386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2113 1.22559L9.21437 0.135223C8.73766 -0.127304 8.12253 0.00367597 7.81168 0.430637L2.2373 8.07285L7.4877 10.9487L11.6397 2.52519C11.8742 2.0523 11.688 1.48131 11.2113 1.22502V1.22559ZM9.10399 3.45736L6.90718 7.29831C6.78308 7.52171 6.49252 7.60053 6.2646 7.46898L5.96748 7.31135C5.73956 7.18661 5.66379 6.90424 5.80161 6.69444L8.19174 2.95895C8.323 2.75539 8.6064 2.68962 8.82059 2.80813L8.92441 2.86086C9.14516 2.9788 9.22153 3.24813 9.10399 3.45849V3.45736Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10419 11.72L1.72253 8.77832L1.90212 12.5405L1.23926 13.6371L2.93192 14.5624L3.59478 13.4664L7.10419 11.72Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0361263 15.621C-0.0664952 15.7894 0.0617816 16.0003 0.266428 16.0003H1.88093C1.9913 16.0003 2.09333 15.9442 2.14882 15.8535L2.48592 15.3018L0.792065 14.377L0.0355297 15.621H0.0361263Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7536 14.8604H4.02489C3.9521 14.8604 3.88289 14.891 3.83635 14.9443L3.24628 15.6173C3.11323 15.7693 3.22659 16 3.43481 16H15.1635C15.2363 16 15.3055 15.9694 15.352 15.9161L15.9421 15.2431C16.0752 15.0911 15.9618 14.8604 15.7536 14.8604Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_14386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighter);
export default __webpack_public_path__ + "static/media/Highlighter.faff896e635835c429fc1c78b44af5a4.svg";
export { ForwardRef as ReactComponent };